import { ChangeEvent, FC } from 'react';
import { FilterProps } from 'react-table';
import { Select } from '@chakra-ui/react';

const BooleanColumnFilter: FC<FilterProps<any>> = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    const type = preFilteredRows[0] ? typeof preFilteredRows[0].values[id] : 'boolean';
    const isStringCheck = ['string', 'number'].includes(type);
    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setFilter(e.target.value || '');
    };

    return (
        <Select size="sm" value={filterValue} onChange={handleChange}>
            <option value=""> ALL </option>
            <option value={isStringCheck ? '1' : 'true'}>Yes</option>
            <option value={isStringCheck ? '0' : 'false'}>No</option>
        </Select>
    );
};

export default BooleanColumnFilter;
